module.exports = __webpack_public_path__ + "img/chat_icon_edit.0d4c7096.svg";